import React from 'react'
import {Grid, Typography, Button, Checkbox} from '@mui/material';
import colors from '../../../../colors'
import SingleInvoice from '../SingleInvoice'
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useDispatch } from 'react-redux';
import {sendGeneralRequest} from '../../../../../features/generalRequest'
import { displayMainUtilityView } from '../../../../../features/taksat/taksatSlice';
import HtmlTooltip from '../../../../general/HtmlTooltip';
import { texts } from '../../../../general/texts';


const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
      backgroundColor: theme.palette.background.paper,
    },
    nested: {
      paddingLeft: theme.spacing(4),
    },
    scrollBar: {
        "&::-webkit-scrollbar": {
          width: "10px",
          height:"50%",
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: '#FFFFFF',
          borderRadius: "10px",
        },
        "&::-webkit-scrollbar-thumb": {
          background: 'linear-gradient(to bottom, #EF7A30, #F0A13D)',
          borderRadius: "10px",
          maxHeight:'50%'
        },
        "&::-webkit-scrollbar-thumb:hover": {
          backgroundColor: 'linear-gradient(to bottom, #EF7A30, #F0A13D)',
        },
          maxHeight:'53vh',
          overflow:'auto',
          paddingLeft:'6%',
          marginTop:'1%',
          '@media (max-width: 899px )' : {height:'80%'}
      }
  }));

const InvoiceList = (props) => 
{
    const dispatch = useDispatch()
    const classes = useStyles();
    const [invoices, setInvoices] = React.useState([])
    const [selectedInvoices, setSelectedInvoices] = React.useState([])
    const [totalSum, setTotalSum] = React.useState(0)

    const handleCheckboxChange = (data, event) =>
    {
        const id = data.detailedInfo['Kodi']
        const value = data.displayInfo['Vlera']
        setSelectedInvoices(
            (selectedInvoices) =>
            {
                if(selectedInvoices.includes(id))
                {   
                    setTotalSum(totalSum => (totalSum - value))
                    return selectedInvoices.filter((f) => f !== id)
                }
                else
                {   
                    setTotalSum(totalSum => (totalSum + value)) 
                    return [...selectedInvoices, id]
                }
            }
        );
    }

    React.useEffect(()=>{ 
        setInvoices(props.invoices)                                                                 
    },[props.invoices])

    return(
        <Grid container p={2.4}>
            <Grid container pt={3} pb={2}>
                <Grid container item md={1.5} xs={3} justifyContent={'left'} alignContent={'center'}><Button onClick={()=> {dispatch(displayMainUtilityView())}} sx={{height:'4rem', borderRadius:'100%',":hover":{background:colors.white}}} ><ArrowBackIosNewIcon color='warning' /></Button></Grid>
                <Grid container item md={10} xs={8} justifyContent={'left'} alignContent={'center'}><Typography sx={{fontFamily:'GerberaBold', color:colors.darkBlue}} variant='h5'>{texts["title-obligations-list"]}</Typography></Grid>
            </Grid>
            <Grid item container md={12} xs={12} pl={'4%'} pb={'3%'}>
                <Typography sx={{color:colors.darkBlue}} variant='h6'>{texts["dialog-gross-amount"]}: {Math.abs(totalSum).toFixed(2)} {texts["currency"]} </Typography>
            </Grid>
            <Grid item container className={classes.scrollBar} maxHeight= {'53vh'} overflow= {'auto'} md={12} xs={12}>
                <List className={classes.root}  >     
                    {invoices.length > 0 && invoices.map((invoice, index) => {
                        return <Grid container item md={12} xs={12} key={index}>
                                    <Grid md={9} xs={9} item>
                                        <SingleInvoice utilityInfo={props.utilityInfo} contractData={invoice.displayInfo} isMultiSelect={true}/>
                                    </Grid>
                                    <Grid container md={1} xs={1} item>                                
                                        <HtmlTooltip invoiceDetails={invoice.detailedInfo}/>
                                    </Grid>
                                    <Grid pt={'4.58%'} md={2} xs={1} item>
                                        {/* <Checkbox id={invoice.detailedInfo['Kodi']} color='warning' sx={{":hover":{background:colors.white}}} contractData={invoice} onChange={handleCheckboxChange}/> */}
                                        <Checkbox color='warning' sx={{":hover":{background:colors.white}}} onChange={(e) => handleCheckboxChange(invoice, e)}/> 
                                    </Grid>
                                </Grid>
                    })}    
                </List>
                                           
            </Grid> 
            <Grid container item justifyContent={'center'} pt={'4%'} md={12}>
                <Button onClick={()=>{dispatch(sendGeneralRequest({request: {token: props.globalDataSliceState.token, localCode: props.taksatSliceState.localCode, obligationCodes: selectedInvoices}, baseUrlKey:'services', endpoint: 'DPTTV/StartTransactionTaxesTirana'}))}} disabled={selectedInvoices.length > 0  ? false : true} sx={{background:colors.gradientOrange ,width:'100%', color:colors.white, fontFamily:"GerberaBold"}}>{texts["title-pay"]}</Button>        
            </Grid>
        </Grid>   
    )
}
export default InvoiceList
